module.exports = __webpack_public_path__ + "img/Photo42.e8cbc137.jpg";